<template>
    <div ref="addedittrip" >
        <b-form ref="tripform" @submit.prevent="saveForm">
            <div class="modal-form-legend">
                <legend v-translate>Details</legend>
            </div>

            <b-form-row>
                <b-col cols="8" lg="9">
                    <b-form-group id="input-group-2a" label-class="gk-label-margin gk-modal-label" label-for="input-2a">
                        <template slot="label">
                            <span v-translate>Date*</span>
                        </template>
                        <b-input-group>
                            <b-form-datepicker id="input-2a" class="inline-form-datepicker" v-model="dateDetail" :required="true" @input="onDateChanged" :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }"></b-form-datepicker>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col cols="4" lg="3">
                    <b-form-group id="input-group-2b" label-class="gk-label-margin gk-modal-label" label-for="input-2b">
                        <template slot="label">
                            <span v-translate>Time*</span>
                        </template>
                        <b-input-group>
                            <TimePicker v-model="timeDetail" :input-id="'input-2b'" :data-type="'date'" :picker-size="'full'" :period="'start'" class="timepicker-style inline-form-datepicker" @input="onDateChanged" @focus-duration="setTimepickerFocus"/>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                        <template slot="label">
                            <span v-translate>Number*</span>
                        </template>
                        <b-input-group>
                            <b-form-input id="input-1" type="text" v-model="tripDetails.number" :required="true" :placeholder="$gettext('2022-000001')" @input="onNumberChange" />
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" label-for="input-3">
                        <template slot="label">
                            <span v-translate>Type*</span>
                        </template>
                        <b-input-group>
                            <b-form-select id="input-3" v-model="tripDetails.type" :options="typeOptions"></b-form-select>
                        </b-input-group>    
                    </b-form-group>
                </b-col>
            </b-form-row>

            <div class="modal-form-legend">
                <legend v-translate>Route</legend>
            </div>

            <b-form-row>
                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" label-for="input-4">
                        <template slot="label">
                            <span v-translate>From*</span>
                        </template>
                        <b-input-group>
                            <GmapAutocomplete
                                v-if="$store.getters['getIsPremium']" 
                                id="input-4" 
                                @place_changed='setStartPlace' 
                                class="form-control" 
                                :value="startDetail"
                                :placeholder="$gettext('Enter a location')"
                                :required="true"
                                @input="changeVModelStartLocation" />
                            <b-form-input v-if="!$store.getters['getIsPremium']" id="input-4" type="text" v-model="tripDetails.start.name" :required="true" :placeholder="$gettext('Amsterdam')" />
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                        <template slot="label">
                            <span v-translate>To*</span>
                        </template>
                        <b-input-group>
                            <GmapAutocomplete 
                                v-if="$store.getters['getIsPremium']" 
                                id="input-5" 
                                @place_changed='setEndPlace' 
                                class="form-control" 
                                :value="endDetail"
                                :placeholder="$gettext('Enter a location')"
                                :required="true" 
                                @input="changeVModelEndLocation" />
                            <b-form-input v-if="!$store.getters['getIsPremium']" id="input-4" type="text" v-model="tripDetails.end.name" :required="true" :placeholder="$gettext('Den Haag')" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col class="form-group">
                    <GekkoButton 
                        @click="calculateRoute()"
                        :text='$gettext("Calculate route")'
                        class="w-100"
                    />
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label" label-for="input-6">
                        <template slot="label">
                            <span v-translate>Transport type*</span>
                        </template>
                        <b-input-group>
                            <b-form-select id="input-6" v-model="tripDetails.transport_type" :options="transportTypeOptions" @change="onTransportTypeChange()" :required="true"></b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-7" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                        <template slot="label">
                            <span v-translate>Select car*</span>
                        </template>
                        <b-input-group>
                            <b-form-select id="input-7" v-model="tripDetails.car" :options="carOptions" :disabled="isCarDisabled" :required="true" @change="calculateOdometer()" ></b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <div v-if="noCarWarning" class="warning-message">
                <span v-translate>You have no cars registered. Go to </span>
                <GekkoButton 
                     @click="manageCars()"
                    :text='$gettext("Manage my cars")'
                    icon="fa-solid fa-pen-to-square"
                    variant="link"
                    class="text-info p-0"
                />
                <span v-translate> to add a car to the list.</span>
            </div>

            <b-form-row>
                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label" label-for="input-8">
                        <template slot="label">
                            <span v-translate>Total distance*</span>
                        </template>
                        <b-input-group>
                            <template #append>
                                <b-input-group-text>km</b-input-group-text>
                            </template>
                            <b-form-input id="input-8" type="number" step="0.1" v-model="tripDetails.total_distance" min="0" :required="true" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                
                <b-col cols="12" lg="6">
                    <b-form-group id="input-group-9" label-class="gk-label-margin gk-modal-label" label-for="input-9">
                        <template slot="label">
                            <span v-translate>of which private</span>
                        </template>
                        <b-input-group>
                            <template #append>
                                <b-input-group-text>km</b-input-group-text>
                            </template>
                            <b-form-input id="input-9" type="number" step="0.1" v-model="tripDetails.private_distance" min="0" :max="tripDetails.total_distance" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" label-for="input-10">
                        <template slot="label">
                            <span v-translate>Odometer*</span>
                        </template>
                        <b-input-group>
                            <template #append>
                                <b-input-group-text>km</b-input-group-text>
                            </template>
                            <b-form-input id="input-10" type="number" step="0.1" v-model="tripDetails.end_odometer" :disabled="isCarDisabled" :required="true" :min="tripDetails.total_distance" />
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <div class="modal-form-legend">
                <legend v-translate>Other</legend>
            </div>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-11" label-class="gk-label-margin gk-modal-label" label-for="input-11">
                        <template slot="label">
                            <span v-translate>Duration</span>
                        </template>
                        <div class="duration-input-group">
                            <b-input-group>
                                <template #append>
                                    <b-input-group-text>h</b-input-group-text>
                                </template>
                                <b-form-input id="input-11a" type="number" v-model="hourDetail" min="0" @input="onDurationChange" />
                            </b-input-group>
                            <b-input-group>
                                <template #append>
                                    <b-input-group-text>m</b-input-group-text>
                                </template>
                                <b-form-input id="input-11b" type="number" v-model="minuteDetail" min="0" @input="onDurationChange" class="ml-2" />
                            </b-input-group>
                        </div>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-12" label-class="gk-label-margin gk-modal-label" label-for="input-12">
                        <template slot="label">
                            <span v-translate>Customer</span>
                        </template>
                        <CustomerSelector v-model="tripDetails.customer" @change="customerCallback" :filters="{owner_company: current_company, is_customer: true, is_archived: false}"></CustomerSelector>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-13" label-class="gk-label-margin gk-modal-label" label-for="input-13">
                        <template slot="label">
                            <span v-translate>Project</span>
                        </template>
                        <b-form-select v-model="tripDetails.project" :disabled="projectList.length===0">
                            <b-form-select-option v-for="project in projectList" :value="project.id" :key="project.id">
                                {{project.name}}
                            </b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-form-row>

            <b-form-row>
                <b-col>
                    <b-form-group id="input-group-14" label-class="gk-label-margin gk-modal-label" label-for="input-14">
                        <template slot="label">
                            <span v-translate>Description</span>
                        </template>
                        <b-input-group>
                            <b-form-textarea id="input-14" type="text" v-model="tripDetails.description" :placeholder="$gettext('Here you can input any extra details about this trip.')"></b-form-textarea>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-form-row>

        </b-form>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import GekkoButton from "@/components/GekkoButton";
import TimePicker from "@/components/hours/TimePicker";
import TripService from "@/store/services/trip.service";
import CarsService from "@/store/services/cars.service";
import CustomerService from "@/store/services/customer.service";
import CustomerSelector from "@/components/CustomerSelector";

export default {
    name: "AddEditTrip",
    components: { GekkoButton, CustomerSelector, TimePicker },
    data() {
        return {
            tripDetails: {
                number: "",
                start: {},
                end: {},
                company_profile: null,
                customer: null,
                project: null,
                car: null,
                created_by: null,
                transport_type: "car",  // default
                type: "business",  // default
                description: "",
                private_distance: 0,
                total_distance: 0,
                end_odometer: 0,
                date: null,
                total_hours: "0.00",
                is_invoiced: false,
                invoice: null,
                route: null,
                raw_route: "",
                created: null,
                modified: null
            },
            current_company: null,
            tripId: null,
            typeOptions: [
                {value: "business", text: this.$gettext("Business")},
                {value: "private", text: this.$gettext("Private")},
                {value: "commuting", text: this.$gettext("Commute")}
            ],
            transportTypeOptions: [
                {value: "car", text: this.$gettext("Car")},
                {value: "train", text: this.$gettext("Public transport")},
                {value: "bike", text: this.$gettext("Bike")}
            ],
            dateDetail: null,
            timeDetail: null,
            hourDetail: 0,
            minuteDetail: 0,
            carOptions: [],
            projectList: [],
            noCarWarning: false,
            startDetail: "",
            endDetail: "",
        }
    },
    computed: {
        ...mapGetters ({ 
            currentUser: 'main/getCurrentUser',
            getCompanyId: 'main/getCompanyId'
        }),
        isCarDisabled() {
            return this.tripDetails.transport_type != "car";
        }
    },
    created() {
        this.tripDetails.created_by = this.currentUser.id
        this.tripDetails.company_profile = this.getCompanyId
        this.current_company = this.getCompanyId

        let vm = this;
        this.$store.commit("tripStore/setMapPolyline", []);
        
        this.tripId = this.$route.params['tripId'];
        if (this.tripId) {
            TripService.retrieve(this.tripId).then(function(response) {
                vm.tripDetails = response.data;
                vm.$store.commit("tripStore/setTripNumber", vm.tripDetails.number);
                vm.$store.commit("tripStore/setTripDetails", vm.tripDetails);
                let dateObj = Date.parse(vm.tripDetails.date);
                let month = dateObj.getMonth() + 1; // getMonth would return a value between 0 and 11
                vm.dateDetail = dateObj.getFullYear() + "-" + month + "-" + dateObj.getDate();
                vm.timeDetail = new Date(vm.tripDetails.date);

                let floatDuration = parseFloat(vm.tripDetails.total_hours);
                vm.hourDetail = parseInt(floatDuration);
                vm.minuteDetail = parseInt(((floatDuration - vm.hourDetail) * 60).toFixed()); // integer value (no seconds allowed)
                vm.startDetail = vm.tripDetails.start.name;
                vm.endDetail = vm.tripDetails.end.name;
                if(vm.tripDetails.customer){
                    vm.customerCallback(vm.tripDetails.customer);
                }
                
                if(vm.tripDetails.route) {
                    TripService.getRoute(vm.tripDetails.id).then((response) => {
                        if (response.status !== 204) {
                            let mapPolyline = TripService.calculatePolyline(response.data)
                            vm.$store.commit("tripStore/setMapPolyline", mapPolyline)
                        }
                    })
                }
            });
        } else { // if it's an adding form, set defaults
            let currentDate = new Date();
            this.dateDetail = currentDate.format('Y-m-d');
            this.timeDetail = currentDate;
            
            let data = {"year": currentDate.getFullYear()};
            TripService.getNextTripNumber(this.getCompanyId, data).then(function(response) {
                vm.tripDetails.number = response.data;
            });
        }

        this.getCars();
    },
    methods: {
        ...mapMutations({
            setWaitingForResponse: 'main/SET_WAITING_FOR_RESPONSE'
        }),
        setTimepickerFocus (value) {
          this.durationTimepickerFocus = value
        },
        onNumberChange(value){
            this.$store.commit("tripStore/setTripNumber", value);
        },
        customerCallback(value){
            let vm = this;
            if(!value){
                this.tripDetails.customer = null;
                this.tripDetails.project = null;
                return;
            }

            CustomerService.retrieve(value, {extended: true}).then(function (response) {
                vm.projectList = response.data.projects;
                vm.projectList.unshift({name: vm.$gettext('Nothing Selected'), id: null});
                for(var i=0; i<vm.projectList.length; i++){
                    if(vm.projectList[i].id === vm.tripDetails.project){
                        return;
                    }
                }
                vm.tripDetails.project = null;
            })
        },
        onDateChanged(){
            this.tripDetails.date = this.createDateTimeObject(this.dateDetail, this.timeDetail);
        },
        onDurationChange(){
            var hour = this.hourDetail ? this.hourDetail : "0";
            var minute = this.minuteDetail ? (this.minuteDetail/60).toFixed(2).toString().split(".")[1] : "00";
            this.tripDetails.total_hours = hour + "." + minute;
        },
        saveForm() {
            if(!this.$refs.tripform.reportValidity())
                return false

            this.setWaitingForResponse(true)

            this.tripDetails.date = this.createDateTimeObject(this.dateDetail, this.timeDetail);
            let vm = this;
            if (this.$store.getters['getIsPremium']) {
                this.tripDetails.start.latitude = parseFloat(this.tripDetails.start.latitude);
                this.tripDetails.start.longitude = parseFloat(this.tripDetails.start.longitude);
                this.tripDetails.end.latitude = parseFloat(this.tripDetails.end.latitude);
                this.tripDetails.end.longitude = parseFloat(this.tripDetails.end.longitude);

                this.tripDetails.start.latitude = this.tripDetails.start.latitude.toFixed(8);
                this.tripDetails.start.longitude = this.tripDetails.start.longitude.toFixed(8);
                this.tripDetails.end.latitude = this.tripDetails.end.latitude.toFixed(8);
                this.tripDetails.end.longitude = this.tripDetails.end.longitude.toFixed(8);
            }
            
            if (this.tripDetails.start.latitude === "NaN")
                this.tripDetails.start.latitude = null
            if (this.tripDetails.start.longitude === "NaN")
                this.tripDetails.start.longitude = null
            if (this.tripDetails.end.latitude === "NaN")
                this.tripDetails.end.latitude = null
            if (this.tripDetails.end.longitude === "NaN")
                this.tripDetails.end.longitude = null

            if (this.tripId == null) {
                TripService.create(this.tripDetails).then(function(response) {
                    vm.$emit("created", response.data);
                    vm.$router.push({name: "Trips"});
                    vm.$store.commit('setAlert', {
                        title: vm.$gettext("Trip added"),
                        text: vm.$gettext("The trip was added to the list."),
                        variant: "success",
                        duration: 4
                    });
                }).catch(function(error) {
                    let msg = vm.$gettext('The trip could not be added to the list.');
                    if (error.data) {
                        let firstDictKey = Object.keys(error.data)[0];
                        if (firstDictKey === "non_field_errors")
                            msg = vm.$gettext("The trip number has already been registered.");
                        else
                            msg = error.data[firstDictKey];
                    }
                    vm.$store.commit('setAlert', {
                        title: vm.$gettext("Error adding trip"),
                        text: msg,
                        variant: "danger",
                        duration: 4
                    });
                }).finally(() => {
                    this.setWaitingForResponse(false);
                });
            } else {
                TripService.update(this.tripId, this.tripDetails).then(function(response) {
                    vm.$emit("updated", response.data);
                    vm.$router.push({name: "Trips"});
                    vm.$store.commit('setAlert', {
                        title: vm.$gettext("Trip edited"),
                        text: vm.$gettext("The trip was edited correctly."),
                        variant: "success",
                        duration: 4
                    });
                }).catch(function (error) {
                    let msg = vm.$gettext('The trip could not be updated.');
                    if (error.data) {
                        let firstDictKey = Object.keys(error.data)[0];
                        msg = error.data[firstDictKey];
                    }
                    vm.$store.commit('setAlert', {
                        title: vm.$gettext("Error editing trip"),
                        text: msg,
                        variant: "danger",
                        duration: 4
                    });
                }).finally(() => {
                    this.setWaitingForResponse(false);
                });
            }
        },
        setStartPlace: function (addressData) {
            this.tripDetails.start = this.getLocationFromAddressData(addressData);
            this.startDetail = this.tripDetails.start.name;
        },
        setEndPlace: function (addressData) {
            this.tripDetails.end = this.getLocationFromAddressData(addressData);
            this.endDetail = this.tripDetails.end.name;
        },
        getLocationFromAddressData(addressData) {
            let country = addressData.address_components.find(item => item.types.includes("country"));
            let country_code = "";
            if (country != null)
                country_code = country.short_name;

            let street = addressData.address_components.find(item => item.types.includes("route"));
            let street_name = "";
            if (street != null)
                street_name = street.short_name;

            let city = addressData.address_components.find(item => item.types.includes("locality"));
            let city_name = "";
            if (city != null)
                city_name = city.long_name;

            let postal_code = addressData.address_components.find(item => item.types.includes("postal_code"));
            let postal_code_str = "";
            if (postal_code != null)
                postal_code_str = postal_code.long_name;

            let administrative_area = addressData.address_components.find(item => item.types.includes("administrative_area_level_1"));
            let region = "";
            if (administrative_area)
                region = administrative_area.long_name;

            return {
                city: city_name,
                country: country_code,
                name: addressData.name,
                latitude: addressData.geometry.location.lat(),
                longitude: addressData.geometry.location.lng(),
                street: street_name,
                postcode: postal_code_str,
                region: region
            };
        },
        calculateRoute() {
            if (this.$store.getters['getIsPremium']) {
                this._calculateRoute();
            } else {
                this.$store.commit('togglePremiumModal', 'web_trips_calculateroute');
            }
        },
        _calculateRoute() {
            let vm = this;

            if (this.tripDetails.start.latitude && this.tripDetails.end.latitude) {
                let params = {
                    origin: new window.google.maps.LatLng(this.tripDetails.start.latitude, this.tripDetails.start.longitude),
                    destination: new window.google.maps.LatLng(this.tripDetails.end.latitude, this.tripDetails.end.longitude),
                    travelMode: this.transportTypeGMap()
                };
                TripService.getDirections(params).then(function(response) {
                    if (!response.routes.length) {
                        vm.$store.commit('setAlert', {
                            title: vm.$gettext("Error calculating the route"),
                            text: vm.$gettext('No routes could be found from the origin to the destination.'),
                            variant: "danger",
                            duration: 4
                        });
                    } else {
                        let route = response.routes[0];
                        vm.tripDetails.total_distance = parseInt(route.legs[0].distance.value / 1000); // meters to KM
                        vm.tripDetails.raw_route = route.overview_polyline;

                        vm.$store.commit("tripStore/setMapPolyline", route.overview_path);

                        let hours = route.legs[0].duration.value / 3600; // seconds to hours
                        vm.hourDetail = parseInt(hours);
                        vm.minuteDetail = parseInt(((hours - vm.hourDetail) * 60).toFixed()); // integer value (no seconds allowed)
                        vm.calculateOdometer();
                        vm.onDurationChange();
                    }
                });
            } else {
                vm.$store.commit('setAlert', {
                    title: vm.$gettext("Error calculating the route"),
                    text: vm.$gettext('No routes could be found from the origin to the destination.'),
                    variant: "danger",
                    duration: 4
                });
            }
        },
        transportTypeGMap() {
            if (this.tripDetails.transport_type === "car")
                return "DRIVING";
            else if (this.tripDetails.transport_type === "train")
                return "TRANSIT";
            else if (this.tripDetails.transport_type === "bike")
                return "BICYCLING";
            return null
        },
        getCars() {
            let vm = this;

            CarsService.list({}, this.getCompanyId).then(function(response) {
                vm.carOptions = response.map(car => {return {value: car.id, text: car.plate_number, archived: car.archived}});
                vm.carOptions = vm.carOptions.filter(car => !car.archived);

                if (!vm.carOptions.length)
                    vm.noCarWarning = true;
                else
                    vm.noCarWarning = false;
                
                if (!vm.tripId && vm.carOptions.length > 0)  // autoselect car when adding trip
                    vm.tripDetails.car = vm.carOptions[0].value;
            });
        },
        createDateTimeObject(date, timeDetail) {
            if (date !== null && timeDetail !== null) {
                var time = timeDetail.getHours() + ":" + timeDetail.getMinutes() + ":" + timeDetail.getSeconds();
                return date.toString() + ' ' + time.toString();
            }
        },
        calculateOdometer() {
            let vm = this;
            if(this.tripDetails.car) {
                CarsService.retrieve(this.tripDetails.car).then(function (response) {
                    vm.tripDetails.end_odometer = parseFloat(response.data.odometer) + parseFloat(vm.tripDetails.total_distance);
                });
            }
        },
        onTransportTypeChange() {
            if (this.tripDetails.transport_type !== "car") {
                this.tripDetails.car = null;
                this.tripDetails.end_odometer = 0;
            } else {
                this.tripDetails.car = this.carOptions[0].value;  // autoselect
                this.calculateOdometer();
            }
                
        },
        changeVModelStartLocation(event) {
            this.startDetail = event.target.value;
            this.tripDetails.start.name = event.target.value;
        },
        changeVModelEndLocation(event) {
            this.endDetail = event.target.value;
            this.tripDetails.end.name = event.target.value;
        },
        manageCars() {
            this.$emit('manageCars');
        }
    }
}
</script>

<style scoped lang="scss">
.duration-input-group {
    display: flex;
}

.warning-message {
    border-radius: $radiusMd;
    background-color: #fcf8e3;
    border: 1px solid #faebcc;
    color: #8a6d3b;
    margin-bottom: 1rem;
    padding: 10px;
    font-size: 16px;
}
</style>

<style lang="scss">
.vue__time-picker{
    &.timepicker-style{
        input {
            &.display-time {
                background-color: $inputBackgroundColor;
                font-size: 16px;
                color: $colorTextBase;
                border: 0;
            }
        }
    }
}

.pac-container, .pac-item {
    z-index: 10000;
    @media (min-width: '768px') {
        width: auto !important;
        max-width: 500px !important;
    }
}

.pac-container {
    box-shadow: $tooltipShadow;
    border-radius: $radiusMd;
    .pac-item {
        padding: 0.25rem 0.5rem;
    }
    &.pac-logo {
        &:after { display: none; }
    }
}
</style>
